import { render } from "./OrdersInfoView.vue?vue&type=template&id=4b24c9d6"
import script from "./OrdersInfoView.vue?vue&type=script&lang=js"
export * from "./OrdersInfoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__